import React, { useEffect, useState } from "react";
import PlusIcon from "assets/icon/PlusIcon";
import TrashIcon from "assets/icon/TrashIcon";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, DropdownStatusList, EmptyString, FormTypeAdd, FormTypeEdit, ModalTypeConfirmation, ModalTypeFail, ModalTypeLoading, ModalTypeSuccess, PageSize, PaginationBack, PaginationFirst, PaginationLast, PaginationNext, StatusCodeActive } from "utils/Constant";
import { ApiGetUserList, ApiDeleteUser, ApiCheckIsAdmin, ApiGetUserOwnerList, ApiDeleteOwnerUser } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import EditIcon from "assets/icon/EditIcon";
import PaginationButton from "components/Input/PaginationButton";
import Dropdown from "components/Input/Dropdown";
import { GetStatus } from "utils/helpers"
import RevisionIcon from "assets/icon/RevisionIcon";
import { useModal } from "components/modal/ModalContext";

export default function User(){
    let navigate = useNavigate()
    const {openModal, closeModal} = useModal()

    const { data: userList, fetch: apiGetUserList } = useFetch(ApiGetUserOwnerList)
    const { fetch: apiDeleteUser } = useFetch(ApiDeleteOwnerUser)

    const [username, setUsername] = useState(EmptyString)
    const [name, setName] = useState(EmptyString)
    const [status, setStatus] = useState(DropdownStatusList[1].value)

    // Grid
    const[paginationOptions, setPaginationOptions] = useState([])
    const[pageIndex, setPageIndex] = useState("")
    const[totalPageCount, setTotalPageCount] = useState(0)

    // Button Event
    const addBtnClick = () => {
        navigate("/setting/user/form?userId=&formType=" + FormTypeAdd)
    }
    const editBtnClick = (id) => {
        navigate("/setting/user/form?userId=" + id + "&formType=" + FormTypeEdit)
    }
    const deleteBtnClick = (id, status) => {
        openModal(ModalTypeConfirmation, {
            onConfirm: () => {
                openModal(ModalTypeLoading)

                deleteUser(id, status).then(() => {
                    fBindGrid(pageIndex)
                    closeModal()
                })
            },
        })
    }

    // Function Api Call
    const getUserList = async(index) => {
        let res

        await apiGetUserList({
            data: {
                username: username,
                name: name, 
                status: status,
                companyId: '',
                pageSize: PageSize,
                pageIndex: parseInt(index)
            }
        }).then((response) => {
            if (checkResponse(response)) {
                res = response
            }
        })

        return res
    }
    const deleteUser = async(userId, status) => {
        await apiDeleteUser({
            data: {
                userId: userId,
                status: status
            }
        }).then((response) => {
            checkResponse(response)
        })
    }

    // Function Grid
    async function fBindGrid(index){
        openModal(ModalTypeLoading)

        let i = index !== null ? (index !== "" ? parseInt(index) : 0) : 0

        getUserList(i).then((res) => {
            if (res !== null){
                let totalData = res.data.totalData
                fSetPaginationOptions(totalData, index)
            }
            
            closeModal()
        })   
    }
    function fSetPaginationOptions(dataCount, index){
        let numberOfPage = parseInt(parseInt(dataCount)/PageSize)
        let array = []
        
        setTotalPageCount(numberOfPage = 0 ? 1 : numberOfPage)

        for (let i = 0; i <= numberOfPage; i++){
            array.push({
                label: String(i + 1),
                value: String(i)
            })
        }
        
        setPaginationOptions(array)
        
        if(index !== "" && index !== null){
            setPageIndex(String(index))
        }else{
            setPageIndex("0")
        }
    }
    function fPaginationBtnClick(command){
        if(command === PaginationFirst){
            setPageIndex("0")
            fBindGrid(0)
        }else if(command === PaginationBack){
            let index = parseInt(pageIndex) - 1

            if(index >= 0){
                setPageIndex(index)
                fBindGrid(index)
            }
        }else if(command === PaginationNext){
            let index = parseInt(pageIndex) + 1

            if (totalPageCount >= index){
                setPageIndex(index)
                fBindGrid(index)
            }
        }else if(command === PaginationLast){
            let index = totalPageCount

            setPageIndex(index)
            fBindGrid(index)
        }
    }
    function fPaginationIndexChange(index){
        setPageIndex(index)
        fBindGrid(index)
    }

    function fEnterKeyDown(e){
		if(e.key === 'Enter'){
			fBindGrid(0)
		}
	}

    const checkResponse = (response) => {
        if(response.status === ApiResponseSuccess){
            return true
        }else if(response.status === ApiResponseStatusUnauthorized){
            window.location.href = "/login"
        }else{
            openModal(ModalTypeFail, { message: response.message })
            return false
        }
    }

    useEffect(() => {
        openModal(ModalTypeLoading)
        
        fBindGrid(0)
    },[username, name, status])

    return(
        <div className="flex flex-col gap-2 sm:p-6 p-3">
            <div >
                <span className="font-semibold text-2xl">User</span>
            </div>
            <hr />

            <div className="flex flex-col sm:flex-row justify-between gap-8 mt-5">
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full">
                    <div className="flex flex-col gap-1 w-full sm:w-[280px]">
                        <span>Username</span>
                        <input className="input" value={username} onChange={(e) => { setUsername(e.target.value) }} onKeyDown={(e) => { fEnterKeyDown(e) }} />
                    </div>
                    <div className="flex flex-col gap-1 w-full sm:w-[280px]">
                        <span>Name</span>
                        <input className="input" value={name} onChange={(e) => { setName(e.target.value) }} onKeyDown={(e) => { fEnterKeyDown(e) }} />
                    </div>
                    <div className="flex flex-col gap-1 w-full sm:w-[120px]">
                        <span>Status</span>
                        <Dropdown value={status} options={DropdownStatusList} onChange={(e) => { setStatus(e.value) }} placeholder={"All"} />
                    </div>
                </div>
            </div>

            <div className="flex w-full justify-end">
                <button className="button flex gap-2" onClick={addBtnClick}>
                    <PlusIcon />
                    <span>Add</span>
                </button>
            </div>
           
            <div className="mt-2 overflow-hidden sm:border sm:rounded-3xl sm:shadow-sm">
                <table className="w-full border bg-white">
                    <thead>
                        <tr className="h-12">
                            <th className="font-semibold w-16">No</th>
                            <th className="font-semibold text-left px-2">Username</th>
                            <th className="font-semibold text-left px-2">Name</th>
                            <th className="font-semibold text-left px-2 hidden sm:table-cell">Status</th>
                            <th className="font-semibold w-auto sm:w-24">Action</th>
                        </tr>
                    </thead>
                    <tbody className="border">
                        { userList?.data?.listData?.map((data, i) => {
                            return(
                                <tr className="my-2 row h-10 border-y hover:bg-slate-100" key={ i }>
                                    <td className="text-center">{ data.rowNumber }</td>
                                    <td className="px-2">
                                        <span>{ data.username }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.fullName }</span>
                                    </td>
                                    <td className="px-2 hidden sm:table-cell">
                                        <span>{ GetStatus(data.status) }</span>
                                    </td>
                                    <td className="flex flex-col sm:flex-row justify-center py-2 gap-2 px-2">
                                        <button className="button flex gap-2" onClick={() => editBtnClick( data.userId )}>
                                            <EditIcon className="w-4 fill-white" />
                                        </button>
                                        <button className={`button flex gap-2`} onClick={() => deleteBtnClick( data.userId, data.status )}>
                                            {data.status === StatusCodeActive ? (<TrashIcon className="w-4 fill-white" />) : (<RevisionIcon className="w-4 fill-white" />)}
                                        </button>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>

            <PaginationButton btnFirstClick={() => { fPaginationBtnClick(PaginationFirst) }} btnBackClick={() => { fPaginationBtnClick(PaginationBack) }} 
                options={paginationOptions} value={pageIndex} onChange={(e) => { fPaginationIndexChange(e.value) }} btnNextClick={() => { fPaginationBtnClick(PaginationNext) }}
                btnLastClick={() => { fPaginationBtnClick(PaginationLast) }}
            />
        </div>
    )
}